






















import { Component, Vue } from 'nuxt-property-decorator'
import headHelper from '~/helper/head'

@Component<FinancialPage>({
  nuxtI18n: {
    paths: {
      en: '/software/financial-and-accounting-systems',
      pl: '/oprogramowanie/systemy-finansowo-ksiegowe'
    }
  },
  head() {
    return headHelper(
      // this.financial[`meta_${this.$i18n.locale}`] || null,
      { title: this.$tc('pages.financial.meta.title') }
    )
  },
  // async asyncData(ctx) {
  //   return await ctx.$axios.get('items/ecommerce', { params: { fields: '*.*' } })
  //     .then(({ data: { data }}) => ({ financial: data || null }))
  //     .catch(() => ({ financial: null }))
  // },
})
export default class FinancialPage extends Vue {
  // financial!: any
}
